const scrollFactory = (window, $, _) => {
  const findIndex = (pred, xs, step) => {
    let i = 0;
    let j = 0;
    while (j < xs.length) {
      if (pred(i)) {
        return i;
      }
      i += 1;
      j += step;
    }
    return -1;
  };

  const animateScrollFactory = (opts, target, scrollProp) => (from, to) => {
    let start = null;
    const c = to - from;

    const step = (timestamp) => {
      if (start === null) {
        start = timestamp;
      }

      const elapsed = timestamp - start;
      target[scrollProp] = opts.easing(elapsed, from, c, opts.duration);

      if (elapsed < opts.duration) {
        window.requestAnimationFrame(step);
      } else {
        target[scrollProp] = to;
      }
    };
    window.requestAnimationFrame(step);
  };

  const _defaults = {
    duration: 300,
    easing: (t, b, c, d) => (c * t) / d + b,
    vertical: false,
    step: 1,
    start: 0,
  };

  /* return */
  return (options, container, items) => {
    const _opts = _.merge(options, _defaults);

    const scrollProp = _opts.vertical ? 'scrollTop' : 'scrollLeft';

    const getScroll = _opts.vertical ? $.scrollTop : $.scrollLeft;
    const getScrollSize = _opts.vertical ? $.scrollHeight : $.scrollWidth;
    const getInnerSize = _opts.vertical ? $.innerHeight : $.innerWidth;
    const getOuterSize = _opts.vertical ? $.outerHeight : $.outerWidth;
    const getOffset = _opts.vertical ? $.offsetTop : $.offsetLeft;

    const _clamp = _.clamp(0, Math.ceil(items.length / _opts.step) - 1);

    const animateScroll = animateScrollFactory(_opts, container, scrollProp);

    const setScroll = (pos) => {
      container[scrollProp] = pos;
    };

    const stepWidth = (j) => {
      let r = 0;
      let i = j * _opts.step;
      const l = i + _opts.step <= items.length ? i + _opts.step : items.length;
      while (i < l) {
        r += getOuterSize(items[i]);
        i += 1;
      }
      return r;
    };

    const posByIndex = (i) =>
      getOffset(items[i * _opts.step]) - getOffset(container);

    const posByIndexR = (i) => posByIndex(i) + stepWidth(i) - 1;

    const indexByPos = (pos, dir) => {
      if (dir === 1) {
        return findIndex((i) => posByIndexR(i) >= pos, items, _opts.step); // rigth
      }
      if (dir === 0) {
        return findIndex((i) => posByIndex(i) >= pos, items, _opts.step); // left
      }
      return findIndex(
          (i) => posByIndex(i) + stepWidth(i) / 2 >= pos,
          items,
          _opts.step,
      ); // .5
    };

    const isAtTheEnd = (scroll = getScroll(container)) =>
      scroll + getInnerSize(container) >= getScrollSize(container);

    const prevPos = (curr) => posByIndex(_clamp(indexByPos(curr, 0) - 1));

    const nextPos = (curr) => posByIndex(_clamp(indexByPos(curr, 1) + 1));

    const set = (n) => {
      const x = posByIndex(_clamp(n));
      // console.log('set...', n);
      return animateScroll(
          getScroll(container),
        isAtTheEnd(x) ? getScrollSize(container) - getInnerSize(container) : x,
      );
    };

    const prev = () => {
      const curr = getScroll(container);
      // console.log('left...', curr);
      return animateScroll(curr, prevPos(curr));
    };

    const next = () => {
      const curr = getScroll(container);
      const x = nextPos(curr);
      // console.log('right...', curr);
      return animateScroll(
          curr,
        isAtTheEnd(x) ? getScrollSize(container) - getInnerSize(container) : x,
      );
    };

    const onResize = _.debounce(false, 150, () => {
      // console.log('scroll onResize');
      const i = indexByPos(getScroll(container));
      setTimeout(() => {
        setScroll(posByIndex(i));
      }, 0);
    });

    const bindEvents = (fn) => {
      fn('resize', onResize, window);
    };

    const destroy = () => {
      bindEvents($.off);
    };

    const init = () => {
      if (items.length === 0) {
        return;
      }
      setTimeout(() => {
        setScroll(posByIndex(_clamp(_opts.start)));
      }, 0);
      bindEvents($.on);
    };

    init();

    return {
      set,
      prev,
      next,
      indexByPos,
      isAtTheEnd,
      destroy,
    };
  };
};

export default scrollFactory;
